import * as React from 'react'
import { FC, useContext } from 'react'

import { TitleContext } from '../TitleDetails'

import Section from '../fragments/Section'

import './Synopsis.scss'

const Synopsis: FC = () => {
    const context = useContext(TitleContext)
    return (
        <Section id="synopsis" className="Synopsis">
            <div className="Synopsis__text">
                <div className="text-wrapper typo">
                    <div dangerouslySetInnerHTML={{ __html: context.titleData.synopsis }}></div>
                </div>
            </div>
        </Section>
    )
}

export default Synopsis
